import Box from 'components/shared/Box'
import { getDayNameAndDate } from 'helpers/dates'
import { useApp } from 'store/steps'
import { Color } from 'styles/types'
import TicketItem from './TicketItem'
import Text from 'components/shared/Text'
import { CabanaReservation } from 'store/selfcare-slice/types'

interface CabanaItemProps {
    cabana: CabanaReservation
    isDisabled?: boolean
}

const CabanaItem = ({ cabana, isDisabled }: CabanaItemProps) => {
    const { stepId } = useApp()
    const isSummary = stepId === 'summary'
    const { changes, original } = cabana
    const dataToDisplay = isSummary && changes ? changes : original
    const { detail } = dataToDisplay || {}
    const { date } = detail || {}

    const isDateChanged =
        changes && changes.detail.date !== original.detail.date
    let cabanaColor: Color = 'grayscale_900'

    if (isDisabled) cabanaColor = 'grayscale_700'

    return (
        <Box gap={[16, 24]} isFullWidth>
            <TicketItem
                date={date ? getDayNameAndDate({ date }) : ''}
                editedItem={isDateChanged ? 'date' : undefined}
                isDisabled={isDisabled}
            >
                <Text variant="bodySmall" color={cabanaColor}>
                    Cabana
                </Text>
            </TicketItem>
        </Box>
    )
}

export default CabanaItem
